import { Type } from '@angular/core';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { MdMenuModule, MdListModule } from '@angular/material';

import { TdMenuComponent } from './menu.component';

const /** @type {?} */ TD_MENU: Type<any>[] = [
  TdMenuComponent,
];

export { TdMenuComponent } from './menu.component';
export class QuiverMenuModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    MdMenuModule,
    MdListModule,
  ],
  declarations: [
    TD_MENU,
  ],
  exports: [
    TD_MENU,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverMenuModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
